var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E673AF0D-9EC7-4E2F-9DA5-1AF7D5DEAEDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-562.000000, -740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-15",
    transform: "translate(562.000000, 740.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,12.5 C10.675,12.5 10,13.175 10,14 C10,14.825 10.675,15.5 11.5,15.5 C12.325,15.5 13,14.825 13,14 C13,13.175 12.325,12.5 11.5,12.5 Z M20.5,12.5 C19.675,12.5 19,13.175 19,14 C19,14.825 19.675,15.5 20.5,15.5 C21.325,15.5 22,14.825 22,14 C22,13.175 21.325,12.5 20.5,12.5 Z M16,12.5 C15.175,12.5 14.5,13.175 14.5,14 C14.5,14.825 15.175,15.5 16,15.5 C16.825,15.5 17.5,14.825 17.5,14 C17.5,13.175 16.825,12.5 16,12.5 Z",
    id: "Icon-Color",
    fill: "#50566E",
    transform: "translate(16.000000, 14.000000) rotate(-90.000000) translate(-16.000000, -14.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,12.5 C6.675,12.5 6,13.175 6,14 C6,14.825 6.675,15.5 7.5,15.5 C8.325,15.5 9,14.825 9,14 C9,13.175 8.325,12.5 7.5,12.5 Z M16.5,12.5 C15.675,12.5 15,13.175 15,14 C15,14.825 15.675,15.5 16.5,15.5 C17.325,15.5 18,14.825 18,14 C18,13.175 17.325,12.5 16.5,12.5 Z M12,12.5 C11.175,12.5 10.5,13.175 10.5,14 C10.5,14.825 11.175,15.5 12,15.5 C12.825,15.5 13.5,14.825 13.5,14 C13.5,13.175 12.825,12.5 12,12.5 Z",
    id: "Icon-Color-Copy",
    fill: "#50566E",
    transform: "translate(12.000000, 14.000000) rotate(-90.000000) translate(-12.000000, -14.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnd);
export default __webpack_public_path__ + "static/media/dnd.6a67431942e2bb52c07e686c39436542.svg";
export { ForwardRef as ReactComponent };